import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import decodeAccessToken from "util/decode_access_token";
import { JWTDecoded, setCodeInLocalStorage } from "util/auth";
import { getUserStorage, saveUserStorage } from "util/local_storage";
import loginApi from "../api/loginApi";

/**
 * hook for login
 */
const useLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({
    password: true,
    email: true,
  });
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    /**
     * init user
     */
    function initUser() {
      const user = getUserStorage();
      if (user?.accessToken) {
        navigate("/");
      }
    }
    initUser();
  }, []);

  const login = async (): Promise<boolean> => {
    setErrorMessage("");
    const result = await loginApi(email, password);

    if (result.errorMessage || !result.data?.access_token) {
      setErrorMessage(result.errorMessage || "ログインに失敗しました。");
      return false;
    }

    const { access_token: accessToken, refresh_token: refreshToken } = result.data;
    const decoded = decodeAccessToken(accessToken) as JWTDecoded;
    if (!decoded) {
      setErrorMessage("ログインに失敗しました。");
      return false;
    }

    const {
      store_name: storeName,
      user_id: userId,
      identification_name: identificationName,
      user_name: userName,
      exp,
    } = decoded || {};
    saveUserStorage({
      accessToken,
      refreshToken,
      userId,
      exp,
      storeName,
      identificationName,
      userName,
    });
    setCodeInLocalStorage(decoded);
    return true;
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const success = await login();
    if (success) {
      const from = (location.state as { from?: string })?.from || "/";
      navigate(from); // 遷移元がない場合はTOP画面に遷移
    }
  };

  return {
    email,
    password,
    errorMessage,
    disableSubmit: errors.email || errors.password,
    setEmail,
    setPassword,
    login,
    handleSubmit,
    setErrors,
  };
};

export default useLogin;
